export default __webpack_public_path__ + "static/media/canvasAndFramedA3Black.ff808fd3.jpg";